/**
 * Was im Reiter des Browsers steht.
 *
 * Vorher stand dort immer nur „Schnitt“ — bei drei offenen Reitern wusste man
 * nicht, welcher welches Projekt ist. Der Titel sagt jetzt, wo man ist, und er
 * sagt es *während* es passiert: läuft ein Export, steht sein Fortschritt
 * vorne, weil man beim Rendern ohnehin woanders hinschaut.
 *
 * Hier liegt nur das Rechnen, damit es Tests dafür gibt; das Setzen steht in
 * `apps/web/src/titel.ts`.
 */
export const APP_NAME = 'SHA TV Schnitt';
/** Der Titel aus seinen Teilen: vorne das Besondere, hinten der Name. */
export function titelText(seite, vorn) {
    const teile = [vorn, seite].filter((t) => typeof t === 'string' && t.trim().length > 0);
    return teile.length ? `${teile.map((t) => t.trim()).join(' · ')} · ${APP_NAME}` : APP_NAME;
}
/**
 * Der vordere Teil, wenn gerade ein Export läuft: „Export 42 %“. Mehrere
 * laufende zählt er zusammen, damit der Reiter nicht flackert; gerundet wird
 * auf ganze Prozent, denn ein Titel, der zehnmal je Sekunde wechselt, ist
 * Unruhe und keine Auskunft. Und er zeigt nie 100 %: fertig ist fertig, dann
 * steht dort gar nichts mehr.
 */
export function exportTitel(renders) {
    const laufend = renders.filter((r) => r.status === 'running' || r.status === 'queued');
    if (laufend.length === 0)
        return null;
    if (laufend.every((r) => r.status === 'queued')) {
        return laufend.length > 1 ? `${laufend.length} Exporte warten` : 'Export wartet';
    }
    const summe = laufend.reduce((a, r) => a + (Number.isFinite(r.progress) ? r.progress : 0), 0);
    const prozent = Math.min(99, Math.max(0, Math.round((summe / laufend.length) * 100)));
    return laufend.length > 1 ? `${laufend.length} Exporte ${prozent} %` : `Export ${prozent} %`;
}
//# sourceMappingURL=titel.js.map